/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';

import type {
    SearchAggregationResult,
    SearchResult,
    SearchSuggestionResult,
} from './search.types';

export async function getSearchResults(params: URLSearchParams, signal?: AbortSignal) {
    return axios
        .get<SearchResult>('/api/search/geo', { params, signal })
        .then(({ data }) => data);
}

export async function getSearchSuggestions(query: string, signal?: AbortSignal) {
    return axios
        .get<SearchSuggestionResult>('/api/search/suggest', {
            params: { q: query, geocoder: 'true' },
            signal,
        })
        .then(({ data }) => data);
}

/**
 * Aggregations for a search, with as few results as the search API allows.
 * `size=0` doesn't work for that: `agg` requests treat it as the default page
 * of 20 results. Counts and `total` don't depend on the page size.
 */
export async function getSearchAggregations(
    params: URLSearchParams,
    signal?: AbortSignal
) {
    const requestParams = new URLSearchParams(params);
    requestParams.set('start', '0');
    requestParams.set('size', '1');

    return axios
        .get<SearchAggregationResult>('/api/search', { params: requestParams, signal })
        .then(({ data }) => data);
}
